var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86804939,4.56473766 L0.53952485,2.23620114 C0.427222063,2.12389835 0.427222063,1.94182718 0.53952485,1.82953637 L0.811109964,1.55795126 C0.923221047,1.44584017 1.1049208,1.44562451 1.21729547,1.557472 L3.07138777,3.40287769 L4.92546808,1.557472 C5.03784276,1.44562451 5.21954251,1.44584017 5.33165359,1.55795126 L5.6032387,1.82953637 C5.71554149,1.94183916 5.71554149,2.12391034 5.6032387,2.23620114 L3.27472614,4.56473766 C3.16242336,4.67702847 2.98035218,4.67702847 2.86804939,4.56473766 Z",
    id: "svg_1",
    className: "selected",
    transform: "rotate(-179.8757781982422 3.0713815689086914,3.0613412857055664) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.efd73e083a221b952bcf752a9a721bc5.svg";
export { ForwardRef as ReactComponent };